import { ApolloProvider } from '@apollo/client';
import { ChakraProvider } from '@chakra-ui/react';
import React from 'react';

import LoadAllScreen from 'components/LoadAllScreen';
import cms from './apis/cms';
import { AuthProvider } from './hooks/useAuth';
import { MenuLocationsProvider } from './hooks/useMenuItemsLocation';
import { CustomTagProvider } from './hooks/useCustomTag';
import { LoadProvider } from './hooks/useLoad';
import Routes from './Routes';
import light from './styles/themes/light';

const App: React.FC = () => {
  return (
    <ApolloProvider client={cms.graphql}>
      <AuthProvider>
        <MenuLocationsProvider>
          <CustomTagProvider>
            <LoadProvider>
              <ChakraProvider theme={light}>
                <Routes />
                <LoadAllScreen />
              </ChakraProvider>
            </LoadProvider>
          </CustomTagProvider>
        </MenuLocationsProvider>
      </AuthProvider>
    </ApolloProvider>
  );
};

export default App;
